import React from 'react';
import {
  Box,
  Chip,
  CircularProgress,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { formatTerminalDate } from '../terminals.utils';

import { STATUS_COLORS, STATUS_LABELS } from '../terminals.types';

const HEADERS = [
  'Nome',
  'Status',
  'Modelo',
  'Serial',
  'Solicitado em',
  'Ações',
];

export default function TableTerminalRegistrationsComponent({
  rows,
  loading,
  onShowQr,
  onRename,
  onDelete,
}: {
  rows: any[];
  loading: boolean;
  onShowQr: (row: any) => void;
  onRename: (row: any) => void;
  onDelete: (row: any) => void;
}) {
  const renderStatus = (row) => (
    <Chip
      size="small"
      label={STATUS_LABELS[row?.status] || row?.status}
      color={(STATUS_COLORS[row?.status] || 'default') as any}
    />
  );

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Typography variant="trasso_heading_small" color="trasso.purple.100">
        Em credenciamento
      </Typography>

      <Box minHeight="120px" position="relative">
        {rows.length > 0 && !loading && (
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  {HEADERS.map((el, idx) => (
                    <TableCell key={`pending-head-${idx}`}>
                      <Typography
                        variant="trasso_heading_extra_small"
                        color="trasso.purple.100"
                      >
                        {el}
                      </Typography>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.id} sx={{ backgroundColor: 'white' }}>
                    <TableCell>
                      <Typography
                        variant="trasso_body_extra_small"
                        color="trasso.purple.100"
                      >
                        {row.alias || '—'}
                      </Typography>
                    </TableCell>
                    <TableCell>{renderStatus(row)}</TableCell>
                    <TableCell>
                      <Typography
                        variant="trasso_body_extra_small"
                        color="trasso.purple.100"
                      >
                        {row.device_model || '—'}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant="trasso_body_extra_small"
                        color="trasso.purple.100"
                      >
                        {row.serial_number || '—'}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant="trasso_body_extra_small"
                        color="trasso.purple.100"
                      >
                        {formatTerminalDate(row.created_at)}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Box display="flex" gap={1}>
                        <Tooltip title="Mostrar QR Code">
                          <IconButton
                            size="small"
                            color="primary"
                            onClick={() => onShowQr(row)}
                          >
                            <QrCode2Icon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Renomear">
                          <IconButton
                            size="small"
                            onClick={() => onRename(row)}
                          >
                            <EditOutlinedIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Excluir">
                          <IconButton
                            size="small"
                            color="error"
                            onClick={() => onDelete(row)}
                          >
                            <DeleteOutlineIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        {rows.length === 0 && !loading && (
          <Box
            border="1px dashed"
            borderColor="trasso.gray.40"
            borderRadius="8px"
            p={4}
            textAlign="center"
          >
            <Typography variant="trasso_body_small" color="trasso.purple.60">
              Nenhum dispositivo em credenciamento.
            </Typography>
          </Box>
        )}

        {loading && (
          <Box
            position="absolute"
            width="100%"
            height="100%"
            minHeight="120px"
            top={0}
            left={0}
            bgcolor="rgba(255,255,255,0.7)"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <CircularProgress />
          </Box>
        )}
      </Box>
    </Box>
  );
}
